export default {
  container: {
    display: 'block',
    marginTop: '20px'
  },
  text: {
    display: 'inline-block',
    minWidth: '150px',
    marginRight: '20px',
    textAlign: 'right',
  },
  value: {
    display: 'inline-block',
    maxWidth: '600px',
    wordBreak: 'break-all',
    wordWrap: 'break-work',
    verticalAlign: 'top'
  },
  inline: {
    display: 'inline-block'
  }
};



// WEBPACK FOOTER //
// ./src/Parts/DetailPart/style.js